import _Icon from './svg-sprite.js';
import '../_chunks/dep-66374d0e.js';
import 'vue';
import './props/props.js';
import '../utils/config-context.js';
import '../utils/use-size-props.js';
import '../utils/use-common-classname.js';
import '../utils/check-url-and-load.js';
import '../style/css.js';

var Icon = _Icon;

export default Icon;
export { Icon };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-icons-vue/esm/svg-sprite/index.js
// module id = null
// module chunks = 